// @ts-nocheck
import { useEffect, useState } from 'react';

interface Position {
  x: number;
  y: number;
}

/**
 * 便利贴拖动行为 hook
 *
 * 返回：
 *   stickyNotePosition   — {x, y} 当前面板位置
 *   isDraggingStickyNote — 是否正在拖动
 *   startDrag(e)         — onMouseDown 处理器，传入鼠标事件
 */
export function useStickyNoteDrag(initialPosition: Position = { x: 0, y: 0 }) {
  const [stickyNotePosition, setStickyNotePosition] = useState<Position>(initialPosition);
  const [isDraggingStickyNote, setIsDraggingStickyNote] = useState<boolean>(false);
  const [dragOffset, setDragOffset] = useState<Position>({ x: 0, y: 0 });

  useEffect(() => {
    if (!isDraggingStickyNote) return;

    const handleMouseMove = (e: MouseEvent) => {
      setStickyNotePosition({
        x: e.clientX - dragOffset.x,
        y: e.clientY - dragOffset.y
      });
    };

    const handleMouseUp = () => {
      setIsDraggingStickyNote(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDraggingStickyNote, dragOffset]);

  const startDrag = (e: React.MouseEvent) => {
    const rect = (e.currentTarget as HTMLElement).parentElement!.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
    setIsDraggingStickyNote(true);
  };

  return { stickyNotePosition, setStickyNotePosition, isDraggingStickyNote, setIsDraggingStickyNote, startDrag };
}
